export interface ActivityLogContentItem {
  id: string;
  projectId: string;
  entityName: string;
  entityId: string;
  propertyName: string;
  oldValue: string;
  newValue: string;
  actionType: string;
  action: string;
  source: string;
  context: string;
  updatedAt: string;
  updatedBy: string;
  updatedByName: string;
}
export interface ActivityLog {
  content: ActivityLogContentItem[];
  last?: boolean;
}

export type ChangeLogState = {
  loading: boolean;
  page: number;
  activityLog: ActivityLog;
};

export const initialState: ChangeLogState = {
  loading: false,
  page: 0,
  activityLog: {
    content: [],
    last: false,
  },
};
